import React, { useRef, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Popup from 'reactjs-popup';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FacebookIcon, FacebookShareButton } from 'react-share';
import qs from 'query-string';
import dayjs from 'dayjs';
import { Helmet } from 'react-helmet-async';

import { vodDetail, vodList, programBoardList, episodeDetail, episodeList, programDetail } from '@/network/apis/apiUri';
import NavData from '@/config/data/nav/nav_data.json';
import useAxios from '@/network/useAxios';
import useContent from '@/localization/data_export';
import analytics from '../../firebase';
import { logEvent } from 'firebase/analytics';
import { sendLogData } from './common_fnc';
import './css/common_video.scss';

function SideEpiList({ listData = [], type, playerId, anchorTitle }) {
  if (!listData || listData.length === 0) return <div>Data가 없습니다...</div>;
  else
    return (
      <ul className="sidelist-wrap">
        {listData.map((v, i) => (
          <li className={`list${v.episode_id === parseInt(playerId) ? ' on' : ''}`} key={i}>
            <Link
              to={`${NavData['VOD_VIEW'].path}?id=${v.episode_id}&board=${v.board_id}&sort=${type}`}
              className="list_link"
              onClick={() => sendLogData({ title: v.title, id: v.episode_id, type: 'episode' })}
              title={anchorTitle}
            >
              <img
                src={v.image_url}
                alt=""
                className="list_img"
                onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
              />
              <div className="list_text">
                <p className="title">{v.title}</p>
                <p className="broadcast time-fs-fixed">{v?.broadcast_date ? v?.broadcast_date?.slice(0, 10) : ''}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    );
}

function CommonVideo({ mode, isRadioPlay, setIsRadioPlay }) {
  const location = useLocation();

  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const parsed = qs.parse(location.search);
  const programType = location.pathname.split('/')[1];
  const vodId = parsed.id;
  const boardId = parsed.board;
  const gubun = parsed.sort;
  const isNewsType = parsed?.type === 'news' ? true : false;
  const today = dayjs.tz().format('YYYY-MM-DD');

  const ago7Day = dayjs.tz().subtract(7, 'day').format('YYYY-MM-DD');
  const ago14Day = dayjs.tz().subtract(14, 'day').format('YYYY-MM-DD');
  const ago60Day = dayjs.tz().subtract(61, 'day').format('YYYY-MM-DD');
  const ago100Day = dayjs.tz().subtract(92, 'day').format('YYYY-MM-DD');

  const subLocation = location.pathname;

  const videoContent = useRef();

  const [url, setUrl] = useState({
    value: window.location.href,
    copied: false,
  });

  const [pageType, setPageType] = useState();
  const [scroll, setScroll] = useState(0);
  const [sideTitle, setSideTitle] = useState();

  const [home, setHome] = useState('');
  const [vodPage, setVodPage] = useState(0);

  const [togBtnText, setTogBtnText] = useState(true);

  const [boardData, setBoardData] = useState({
    lan_code: mode,
    board_id: boardId,
    type: 'vod',
    page_info: { row_count: 10, number: 0 },
  });

  const [episodeData, setEpisodeData] = useState({
    board_id: boardId,
    lan_code: mode,
    page_info: {
      row_count: 10,
      number: 0,
    },
  });

  const [latestEpiPost, setLatestEpiPost] = useState({
    lan_code: mode,
    is_news_allow: false,
    start_reg_date: ago7Day,
    end_reg_date: today,
  });

  const popularEpiPost = {
    lan_code: mode,
    is_news_allow: false,
    start_reg_date: ago14Day,
    end_reg_date: today,
    is_hit_count: true,
    page_info: { row_count: 5, number: 0 },
  };

  const [newsEpisodeData, setNewsEpisodeData] = useState({
    lan_code: mode,
    is_news_allow: true,
    page_info: {
      row_count: 10,
      number: 0,
    },
  });

  const [recoData, setRecoData] = useState({
    lan_code: mode,
    board_id: boardId,
    board_item_type: 'episode',
    is_open_allow: true,
    hit: true,
    col_order: 'desc',
    page_info: { row_count: 30, number: 0 },
  });

  const [recoRadioData, setRecoRadioData] = useState({
    lan_code: mode,
    board_id: boardId,
    board_item_type: 'vod',
    is_open_allow: true,
    hit: true,
    page_info: { row_count: 30, number: 0 },
  });

  function checkSideTitle() {
    switch (gubun) {
      case 'latestVod':
        return 'Latest VOD';
      case 'Latest':
        return 'Latest CLIP';
      case 'popularVod':
      case 'popular':
        return 'Most popular';
      case 'recoVod':
        return 'Recommended VOD';
      case 'reco2':
        return 'Recommended VOD';
      case 'episode':
        return 'Episode';
      default:
        return 'VOD';
    }
  }

  const onScroll = () => {
    const scrollTop = document.getElementById('content_list_content')?.scrollTop;
    setScroll(scrollTop);
  };

  const listToggleFnc = () => {
    if (videoContent.current.classList.contains('off')) {
      videoContent.current.classList.replace('off', 'on');
    } else {
      videoContent.current.classList.replace('on', 'off');
    }
    setTogBtnText(!togBtnText);
  };

  const playerOnload = () => {
    if (location.pathname.split('/')[1] === 'radio') {
      const videoOnloadController = new window.VgControllerClient({
        target_window: document.getElementById('vodchild').contentWindow,
      });
      setIsRadioPlay((prev) => ({ ...prev, vodRef: videoOnloadController }));
      videoOnloadController
        .on('play', function () {
          setIsRadioPlay((prev) => ({ ...prev, vod: true }));
        })
        .on('pause', function () {
          setIsRadioPlay((prev) => ({ ...prev, vod: false }));
        });
    }
  };

  const getTags = (tags) => {
    if (!tags) {
      return '';
    } else {
      return tags.join(', ');
    }
  };

  const [boardItem, boardItemRefetch] = useAxios(vodList, [], {}, false);
  const [vodItem, vodItemRefetch] = useAxios(vodList, [], {}, false);
  const [popularItem, popularRefetch] = useAxios(vodList, [], {}, false);

  const [vodDetailItem, vodDetailRefetch] = useAxios(vodDetail, [], {}, false);
  const [boardRecoItem, boardRecoItemRefetch] = useAxios(programBoardList, [], {}, false);

  const [epiItem, epiRefetch] = useAxios(episodeList, [], {}, false);

  const [epiDetailItem, epiDetailRefetch] = useAxios(episodeDetail, [], {}, false);

  const [preDetailItem, preDetailRefetch] = useAxios(programDetail, [], {}, false);

  const { data: detailData } = vodDetailItem;

  const { data: boardListData } = boardItem;
  const { data: vodListData } = vodItem;
  const { data: popularData } = popularItem;

  const { data: boardRecoList } = boardRecoItem;
  const { data: epiListData } = epiItem;
  const { data: epiDetailData } = epiDetailItem;

  const { data: preDetailData } = preDetailItem;

  const [detail, setDetail] = useState();
  const [boardList, setBoardList] = useState([]);
  const [epiList, setEpiList] = useState([]);

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { capture: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (gubun === 'episode' || gubun === 'latestVod' || gubun === 'popularVod') {
      epiDetailRefetch({ episode_id: vodId, hit: true });
    } else if (gubun === 'recoVod') {
      epiDetailRefetch({ episode_id: vodId, hit: true });
      setRecoData({ ...recoData, board_id: boardId });
    } else if (gubun === 'vod' || gubun === 'Latest' || gubun === 'popular' || gubun === 'reco2') {
      vodDetailRefetch({ vod_id: vodId, hit: true });
      setRecoRadioData({ ...recoRadioData, board_id: boardId });
    }
  }, [vodId, boardId, boardData]);
  //--------------------------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    if (gubun === 'latestVod') {
      setLatestEpiPost((prev) => ({
        ...prev,
        page_info: { row_count: 10, number: 0 },
      }));
      setVodPage(0);
    } else if (gubun === 'popularVod') epiRefetch(popularEpiPost);
    setEpiList([]);
    setSideTitle(checkSideTitle());
  }, [gubun]);

  useEffect(() => {
    if (vodPage)
      setLatestEpiPost((prev) => ({
        ...prev,
        page_info: { row_count: 10, number: vodPage },
      }));
  }, [vodPage]);

  useEffect(() => {
    if (gubun === 'latestVod' && latestEpiPost.page_info) {
      epiRefetch(latestEpiPost);
    }
  }, [latestEpiPost]);

  useEffect(() => {
    if (recoData && gubun === 'recoVod') {
      boardRecoItemRefetch(recoData);
    }
    if (recoRadioData && gubun === 'reco2') {
      boardRecoItemRefetch(recoRadioData);
    }

    if (boardData) {
      boardItemRefetch(boardData);
    }

    if (episodeData && gubun === 'episode') {
      if (!isNewsType) {
        epiRefetch(episodeData);
      }
    }

    if (newsEpisodeData && gubun === 'episode') {
      if (isNewsType) {
        epiRefetch(newsEpisodeData);
      }
    }
  }, [recoData, boardData, episodeData, newsEpisodeData, recoRadioData]);

  useEffect(() => {
    if (epiDetailData || detailData) {
      if (gubun === 'Latest') {
        vodItemRefetch({
          lan_code: mode,
          program_type: programType === 'radio' ? 'radio' : 'tv',
          type: 'vod',
          start_reg_date: ago100Day,
          end_reg_date: today,
          page_info: { row_count: 50, number: 0 },
        });
      }
      if (gubun === 'popular') {
        popularRefetch({
          lan_code: mode,
          program_type: 'tv',
          type: 'vod',
          board_id: programType === 'tv' ? boardId : null,
          is_hit_count: true,
          start_reg_date: ago60Day,
          end_reg_date: today,
          page_info: { row_count: 50, number: 0 },
        });
      }
      if (gubun === 'episode' || gubun === 'latestVod' || gubun === 'popularVod' || gubun === 'recoVod') {
        setDetail(epiDetailData);
      } else {
        setDetail(detailData);
      }
    }
  }, [epiDetailData, detailData, boardId, gubun]);

  useEffect(() => {
    if (boardListData?.item?.length) {
      setBoardList(boardListData.item);
    }
  }, [boardListData]);

  useEffect(() => {
    if (epiListData) setEpiList((prev) => [...prev, ...epiListData.item]);
  }, [epiListData]);

  useEffect(() => {
    if (scroll) {
      let scrollHeights = document.getElementById('content_list_content')?.scrollHeight;
      if (scrollHeights && scroll + 672 >= scrollHeights) {
        if (gubun === 'episode') {
          if (isNewsType) {
            setNewsEpisodeData({
              ...newsEpisodeData,
              page_info: { row_count: 10, number: newsEpisodeData.page_info.number + 1 },
            });
          } else {
            setEpisodeData((prev) => ({
              ...prev,
              page_info: { row_count: 10, number: prev.page_info.number + 1 },
            }));
          }
        } else if (gubun === 'vod') {
          setBoardData({
            ...boardData,
            page_info: { row_count: boardData.page_info.row_count + 5, number: boardData.page_info.number },
          });
        } else if (gubun === 'latestVod') {
          setVodPage((prev) => prev + 1);
        }
      }
    }
  }, [scroll]);

  useEffect(() => {
    if (isRadioPlay?.vod && isRadioPlay?.vodRef && isRadioPlay?.aod?.[0] !== -1) {
      if (isRadioPlay.aod.length !== 0 && isRadioPlay?.vod) {
        isRadioPlay.vodRef.play();
        isRadioPlay.aod[0] = -1;
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: false,
          radioPlayed: false,
          podcastPlayed: false,
        }));
        isRadioPlay.aodController[0].pause();
      } else {
        isRadioPlay.footerRef?.pause();
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: false,
          radioPlayed: false,
          podcastPlayed: false,
        }));
      }
    }
  }, [isRadioPlay?.vod]);

  useEffect(() => {
    if (detail) {
      setHome(detail.program_id);
      preDetailRefetch({
        program_id: detail.program_id,
        lan_code: mode,
      });
    }
  }, [detail]);

  useEffect(() => {
    const path = location.pathname;

    if (path.match(/tv/i)) {
      setPageType('TV');
    } else if (path.match(/radio/i)) {
      setPageType('RADIO');
    } else if (path.match(/news/i)) {
      setPageType('NEWS');
    } else if (path.match(/live/i)) {
      setPageType('LIVE');
    }
  }, [location]);
  return (
    <section id="CommonVideo" className="commonVideo content off" ref={videoContent}>
      <Helmet>
        <title>{`${
          mode === 'en' ? detail?.title?.[0]?.text : detail?.title?.[1]?.text
        } - ${pageType} | Arirang`}</title>
      </Helmet>
      <div className="content_vod">
        <div className="pWidth">
          {detail?.media_info?.media_content_key ? (
            <iframe
              title="contentPlayer"
              className="content_vod_content"
              id="vodchild"
              src={`https://v.kr.kollus.com/${detail?.media_info?.media_content_key}?enable_pip=true`}
              frameBorder="0"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              key={detail?.media_info.media_content_key}
              onLoad={() => playerOnload()}
            ></iframe>
          ) : (
            <img
              src={`${detail?.image !== null ? detail?.image?.url : detail?.program_image?.url}`}
              alt={detail?.title?.[0]?.text}
              className="list_img"
              style={{ width: '100%' }}
              onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
            />
          )}
        </div>
        <div className="content_vod_info">
          <button type="button" className="btnListToggle" onClick={listToggleFnc}>
            List {togBtnText ? 'off' : 'on'}
          </button>
          <p className="subTitle time-fs-fixed">
            {detail?.broadcast_date && `${detail?.broadcast_date?.substring(0, 10)} KST`}
          </p>
          <h2 className="title">{mode === 'en' ? detail?.title?.[0]?.text : detail?.title?.[1]?.text}</h2>
          <p
            className={`text style-scroll ${
              location.pathname.split('/')[1] === 'radio' && location.pathname.split('/')[3] === 'vod'
                ? 'radio-pro-vod'
                : ''
            }`}
            dangerouslySetInnerHTML={{
              __html:
                mode === 'en'
                  ? detail?.content[0]?.text?.replace(/\.{3}/gi, '&nbsp;')
                  : detail?.content[1]?.text === '' || detail?.content[1]?.text.length === 0
                  ? detail?.content[0]?.text?.replace(/\.{3}/gi, '&nbsp;')
                  : detail?.content[1]?.text?.replace(/\.{3}/gi, '&nbsp;'),
            }}
          />
          {!isNewsType && <p className="text tag">{getTags(detail?.tag)}</p>}
          <div className="info">
            <Link
              to={
                programType === 'radio' ? `${NavData['RADIO_MAIN'].path}/${home}` : `${NavData['TV_MAIN'].path}/${home}`
              }
              className="info_home"
              title={anchorTitle}
            >
              {preDetailData
                ? preDetailData.title?.[0]?.text
                : detail?.bis_program_code?.[2]
                ? detail?.bis_program_code?.[2]?.bis_program_title
                : detail?.bis_program_code?.[0]?.bis_program_title}
            </Link>
            {!isNewsType && (
              <Popup
                trigger={(isOpen) => (
                  <button
                    type="button"
                    className="info_share"
                    title={
                      isOpen
                        ? mode === 'en'
                          ? 'Close the share popup'
                          : '공유 팝업 닫기'
                        : mode === 'en'
                        ? 'Open the share popup'
                        : '공유 팝업 열기'
                    }
                  >
                    <span className="sr-only">
                      {isOpen
                        ? mode === 'en'
                          ? 'Close the share popup'
                          : '공유 팝업 닫기'
                        : mode === 'en'
                        ? 'Open the share popup'
                        : '공유 팝업 열기'}
                    </span>
                  </button>
                )}
                position="right top"
                closeOnDocumentClick
              >
                <div id="popupShare" className="popupShare">
                  <h3 className="popupShare_title">
                    <em className="style-font">Sharing</em> Link
                  </h3>
                  <div className="popupShare_btnWrap">
                    <FacebookShareButton
                      className="button"
                      url={'https://www.arirang.com/vod/view/?id=' + vodId}
                      title={mode === 'en' ? 'Shared to Facebook' : '페이스북으로 공유'}
                      quote={mode === 'en' ? detail?.content?.[0]?.text : detail?.content?.[1]?.text}
                    >
                      <FacebookIcon size={40} round />
                    </FacebookShareButton>
                    <button
                      className="share-x"
                      role="link"
                      title={mode === 'en' ? 'Share on X' : 'X로 공유'}
                      onClick={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?url=${
                            'https://www.arirang.com/vod/view/?id=' + vodId
                          }&text=${mode === 'en' ? detail?.content?.[0]?.text : detail?.content?.[1]?.text}`,
                          'intent',
                          'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,data-text=test'
                        );
                      }}
                    >
                      <img
                        src={require('@/assets/images/icon/sns/sns_x_b.png').default}
                        alt={mode === 'en' ? 'New window Opend' : '새창 열림'}
                      />
                    </button>
                    <CopyToClipboard text={url.value} onCopy={(value) => setUrl({ value: `${value}`, copied: true })}>
                      <button
                        type="button"
                        className="button btnLink"
                        title={mode === 'en' ? 'Copy page url' : '페이지 링크 복사'}
                      />
                    </CopyToClipboard>
                  </div>
                </div>
              </Popup>
            )}
          </div>
          {isNewsType && (
            <div className="opentype">
              <p className="opentype_text">
                본 저작물 중 본문에 해당하는 뉴스 스크립트(텍스트)는 공공누리 제1유형-출처표시 조건에 따라 이용할 수
                있습니다.
              </p>
              <img
                src={process.env.PUBLIC_URL + '/images/img_opentype01.svg'}
                alt="opentype mark"
                className="opentype_img"
              />
            </div>
          )}
        </div>
      </div>
      <div className="content_list">
        <div className="content_list_top">
          <h3 className="title">
            <em className="style-font">{sideTitle}</em>
          </h3>
          <p className="num"></p>
        </div>
        <div className="content_list_content-wrap">
          <div id="content_list_content" className="content_list_content style-scroll">
            {gubun !== 'popularVod' && gubun !== 'latestVod' ? (
              <ul className="sidelist-wrap">
                {gubun === 'recoVod'
                  ? boardRecoList &&
                    boardRecoList?.item?.map((v, i) => {
                      return (
                        !v.url_link?.[0] && (
                          <li
                            className={`list ${String(v.episodes?.[0]?.episode_id) === String(vodId) && 'on'}`}
                            key={i}
                          >
                            <Link
                              to={
                                v.episodes?.[0]?.episode_id
                                  ? `${subLocation}?id=${v.episodes?.[0]?.episode_id}&board=${v.board_id}&sort=recoVod`
                                  : NavData['VOD_VIEW'].path
                              }
                              className="list_link"
                              onClick={() =>
                                subLocation.split('/')[1] !== 'radio'
                                  ? logEvent(analytics, 'select_item', {
                                      item_list_name: `${v.title}`,
                                      item_list_id: `vod_${v?.episodes?.[0]?.episode_id}`,
                                      items: [
                                        {
                                          item_id: `${v.episodes?.[0]?.episode_id}`,
                                          item_name: `${v.title}`,
                                          item_brand: 'vod',
                                        },
                                      ],
                                    })
                                  : logEvent(analytics, 'select_item', {
                                      item_list_name: `${v.title}`,
                                      item_list_id: `vod_${v?.episodes?.[0]?.episode_id}`,
                                      items: [
                                        {
                                          item_id: `${v.episodes?.[0]?.episode_id}`,
                                          item_name: `${v.title}`,
                                          item_brand: 'vod',
                                        },
                                      ],
                                    })
                              }
                              title={anchorTitle}
                            >
                              <img
                                src={`${v.episodes?.[0]?.image_url}`}
                                alt=""
                                className="list_img"
                                onError={(e) =>
                                  (e.target.src = require('@/assets/images/common/672_379_A.png').default)
                                }
                              />
                              <div className="list_text">
                                <p className="title">{v.title}</p>
                                <p className="broadcast time-fs-fixed">
                                  {v?.episodes?.[0]?.broadcast_date
                                    ? v?.episodes?.[0]?.broadcast_date?.slice(0, 10)
                                    : ''}
                                </p>
                              </div>
                            </Link>
                          </li>
                        )
                      );
                    })
                  : gubun === 'reco2'
                  ? boardRecoList &&
                    boardRecoList?.item.map((v, i) => {
                      return (
                        <li className={`list ${String(v.vods?.[0]?.vod_id) === String(vodId) && 'on'}`} key={i}>
                          <Link
                            to={
                              v.vods?.[0]?.vod_id
                                ? `${subLocation}?id=${v.vods?.[0]?.vod_id}&board=${v.board_id}&sort=reco2`
                                : NavData['VOD_VIEW'].path
                            }
                            className="list_link"
                            onClick={() =>
                              subLocation.split('/')[1] !== 'radio'
                                ? logEvent(analytics, 'select_item', {
                                    item_list_name: `${v.title}`,
                                    item_list_id: `vod_${v?.vods?.[0]?.vod_id}`,
                                    items: [
                                      {
                                        item_id: `${v.vods?.[0]?.vod_id}`,
                                        item_name: `${v.title}`,
                                        item_brand: 'vod',
                                      },
                                    ],
                                  })
                                : logEvent(analytics, 'select_item', {
                                    item_list_name: `${v.title}`,
                                    item_list_id: `vod_${v?.vods?.[0]?.vod_id}`,
                                    items: [
                                      {
                                        item_id: `${v.vods?.[0]?.vod_id}`,
                                        item_name: `${v.title}`,
                                        item_brand: 'vod',
                                      },
                                    ],
                                  })
                            }
                            title={anchorTitle}
                          >
                            <img
                              src={`${v.vods?.[0]?.image_url}`}
                              alt=""
                              className="list_img"
                              onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                            />
                            <div className="list_text">
                              <p className="title">{v.title}</p>
                              <p className="broadcast time-fs-fixed">
                                {v?.vods?.[0]?.broadcast_date ? v?.vods?.[0]?.broadcast_date?.slice(0, 10) : ''}
                              </p>
                            </div>
                          </Link>
                        </li>
                      );
                    })
                  : gubun === 'popular'
                  ? popularData?.item?.map((v, i) => {
                      return (
                        <li className={`list ${String(v.vod_id) === String(vodId) && 'on'}`} key={i}>
                          <Link
                            to={
                              v.vod_id
                                ? `${subLocation}?id=${v.vod_id}&board=${v.board_id}&sort=popular`
                                : NavData['VOD_VIEW'].path
                            }
                            className="list_link"
                            onClick={() =>
                              logEvent(analytics, 'select_item', {
                                item_list_name: `${v.title}`,
                                item_list_id: `vod_${v?.vod_id}`,
                                items: [
                                  {
                                    item_id: `${v.vod_id}`,
                                    item_name: `${v.title}`,
                                    item_brand: 'vod',
                                  },
                                ],
                              })
                            }
                            title={anchorTitle}
                          >
                            <img
                              src={v.image_url}
                              alt=""
                              className="list_img"
                              onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                            />
                            <div className="list_text">
                              <p className="title">{v.title}</p>
                              <p className="broadcast time-fs-fixed">
                                {v?.broadcast_date ? v?.broadcast_date?.slice(0, 10) : ''}
                              </p>
                            </div>
                          </Link>
                        </li>
                      );
                    })
                  : gubun === 'episode'
                  ? epiList?.map((v, i) => {
                      if (isNewsType) {
                        return (
                          <li className={`list ${String(v.episode_id) === String(vodId) && 'on'}`} key={i}>
                            <Link
                              to={
                                v.episode_id
                                  ? `${subLocation}?id=${v.episode_id}&board=${v.board_id}&sort=episode&type=news`
                                  : NavData['VOD_VIEW'].path
                              }
                              className="list_link"
                              onClick={() =>
                                logEvent(analytics, 'select_item', {
                                  item_list_name: `${v.title}`,
                                  item_list_id: `episode_${v.episode_id}`,
                                  items: [
                                    {
                                      item_id: `${v.episode_id}`,
                                      item_name: `${v.title}`,
                                      item_brand: 'episode',
                                    },
                                  ],
                                })
                              }
                              title={anchorTitle}
                            >
                              <img
                                src={v.image_url !== null ? v.image_url : v.program_image?.url}
                                alt=""
                                className="list_img"
                                onError={(e) =>
                                  (e.target.src = require('@/assets/images/common/672_379_A.png').default)
                                }
                              />
                              <div className="list_text">
                                <p className="title">{v.title}</p>
                                <p className="broadcast time-fs-fixed">
                                  {v?.broadcast_date ? v?.broadcast_date?.slice(0, 10) : ''}
                                </p>
                              </div>
                            </Link>
                          </li>
                        );
                      } else {
                        return (
                          String(boardId) === String(v.board_id) && (
                            <li
                              className={`list ${String(v.episode_id) === String(vodId) && 'on'}`}
                              key={v.board_item_id}
                            >
                              <Link
                                to={
                                  v.episode_id
                                    ? `${subLocation}?id=${v.episode_id}&board=${v.board_id}&sort=episode`
                                    : NavData['VOD_VIEW'].path
                                }
                                className="list_link"
                                onClick={() =>
                                  logEvent(analytics, 'select_item', {
                                    item_list_name: `${v.title}`,
                                    item_list_id: `episode_${v.episode_id}`,
                                    items: [
                                      {
                                        item_id: `${v.episode_id}`,
                                        item_name: `${v.title}`,
                                        item_brand: 'episode',
                                      },
                                    ],
                                  })
                                }
                                title={anchorTitle}
                              >
                                <img
                                  src={v.image_url !== null ? v.image_url : v.program_image?.url}
                                  alt=""
                                  className="list_img"
                                  onError={(e) =>
                                    (e.target.src = require('@/assets/images/common/672_379_A.png').default)
                                  }
                                />
                                <div className="list_text">
                                  <p className="title">{v.title}</p>
                                  <p className="broadcast time-fs-fixed">
                                    {v?.broadcast_date ? v?.broadcast_date?.slice(0, 10) : ''}
                                  </p>
                                </div>
                              </Link>
                            </li>
                          )
                        );
                      }
                    })
                  : gubun === 'Latest'
                  ? vodListData?.item?.map((v, i) => {
                      return (
                        <li className={`list ${String(v.vod_id) === String(vodId) && 'on'}`} key={i}>
                          <Link
                            to={
                              v.vod_id
                                ? `${subLocation}?id=${v.vod_id}&board=${v.board_id}&sort=Latest`
                                : NavData['VOD_VIEW'].path
                            }
                            className="list_link"
                            onClick={() =>
                              subLocation.split('/')[1] !== 'radio'
                                ? logEvent(analytics, 'select_item', {
                                    item_list_name: `${v.title}`,
                                    item_list_id: `vod_${v.vods?.[0]?.vod_id}`,
                                    items: [
                                      {
                                        item_id: `${v.vods?.[0]?.vod_id}`,
                                        item_name: `${v.title}`,
                                        item_brand: 'vod',
                                      },
                                    ],
                                  })
                                : logEvent(analytics, 'select_item', {
                                    item_list_name: `${v.title}`,
                                    item_list_id: `vod_${v.vods?.[0]?.vod_id}`,
                                    items: [
                                      {
                                        item_id: `${v.vods?.[0]?.vod_id}`,
                                        item_name: `${v.title}`,
                                        item_brand: 'vod',
                                      },
                                    ],
                                  })
                            }
                            title={anchorTitle}
                          >
                            <img
                              src={v.image_url}
                              alt=""
                              className="list_img"
                              onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                            />
                            <div className="list_text">
                              <p className="title">{v.title}</p>

                              <p className="broadcast time-fs-fixed">
                                {v?.broadcast_date ? v?.broadcast_date?.slice(0, 10) : ''}
                              </p>
                            </div>
                          </Link>
                        </li>
                      );
                    })
                  : boardList?.map((v, i) => {
                      return (
                        String(boardId) === String(v.board_id) && (
                          <li className={`list ${String(v.vod_id) === String(vodId) && 'on'}`} key={i}>
                            <Link
                              to={
                                v.vod_id
                                  ? `${subLocation}?id=${v.vod_id}&board=${v.board_id}&sort=vod`
                                  : NavData['VOD_VIEW'].path
                              }
                              className="list_link"
                              onClick={() =>
                                logEvent(analytics, 'select_item', {
                                  item_list_name: `${v.title}`,
                                  item_list_id: `vod_${v.vods?.[0]?.vod_id}`,
                                  items: [
                                    {
                                      item_id: `${v.vods?.[0]?.vod_id}`,
                                      item_name: `${v.title}`,
                                      item_brand: 'vod',
                                    },
                                  ],
                                })
                              }
                              title={anchorTitle}
                            >
                              <img
                                src={v.image_url}
                                alt=""
                                className="list_img"
                                onError={(e) =>
                                  (e.target.src = require('@/assets/images/common/672_379_A.png').default)
                                }
                              />
                              <div className="list_text">
                                <p className="title">{v.title}</p>
                                <p className="broadcast time-fs-fixed">
                                  {v?.broadcast_date ? v?.broadcast_date?.slice(0, 10) : ''}
                                </p>
                              </div>
                            </Link>
                          </li>
                        )
                      );
                    })}
              </ul>
            ) : (
              <SideEpiList listData={epiList} type={gubun} playerId={vodId} anchorTitle={anchorTitle} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CommonVideo;
